import { render, staticRenderFns } from "./RealmMarketplaceView.vue?vue&type=template&id=6fb4ed14&scoped=true"
import script from "./RealmMarketplaceView.vue?vue&type=script&lang=js"
export * from "./RealmMarketplaceView.vue?vue&type=script&lang=js"
import style0 from "./RealmMarketplaceView.vue?vue&type=style&index=0&id=6fb4ed14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4ed14",
  null
  
)

export default component.exports